define([
    'text!product-detail/component/feature-item.html',
    'product-detail/component/feature-item1',
    'product-detail/component/feature-item2',
    'product-detail/component/feature-item3',

    'css!product-detail/component/feature-item.css'
], function(
    tpl,
    FeatureItem1,
    FeatureItem2,
    FeatureItem3
){
    return {
        template: tpl,
        props: {
            item: {
                type: Object
            },
            index: {
                type: String
            }
        },
        components: {
            FeatureItem1: FeatureItem1,
            FeatureItem2: FeatureItem2,
            FeatureItem3: FeatureItem3
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/feature-item.js
// module id = 139
// module chunks = 0